/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// import User from 'global/user';
import Nav from 'global/nav';
import Flag from 'global/flag';
import Popup from 'global/popup';
import Pagination from 'global/pagination';
import Fader from 'global/fader';
import Recirculation from 'global/recirculation';
// import Account from 'account';
import Homepage from 'homepage';
import Articles from 'articles';
import Museboard from 'articles/museboard';
import Disciplines from 'disciplines';
import Musts from 'musts';
import Creators from 'creators';
import Terms from 'terms';
import About from 'about';

class App {
  constructor() {

    this.elems = {};
    this.elems.$site = document.getElementById('site');
    this.elems.$home = document.getElementById('home');
    this.elems.$article = document.getElementById('article-show');

    /**
      * Sitewide
      */
    // this.User          = new User(this.elems);
    this.Nav           = new Nav(this.elems);
    // this.Login         = new Flag('Login', this.elems);
    // this.Flash         = (document.getElementById('flash')) ? new Flag('Flash', this.elems) : null;
    // this.Reset         = new Flag('Reset Password', this.elems);
    // this.Signup        = new Flag('Signup', this.elems);
    this.Search        = new Flag('Search', this.elems);
    this.Popup         = new Popup(this.elems); 
    this.Pagination    = new Pagination(this.elems);
    this.Fader         = new Fader();
    this.Recirculation = (document.getElementsByClassName('recirculation-slider')) ? new Recirculation() : null;

    /**
      * Routes
      */
    // this.Account      = (document.getElementById('account')) ? new Account(this.elems) : null;
    this.Homepage     = (document.getElementById('home')) ? new Homepage(this.elems.$home) : null;
    this.Articles     = (document.getElementById('articles') || document.getElementById('article-show') || document.getElementById('styleguide') || document.getElementById('must-show')) ? new Articles(this.elems) : null;
    this.Disciplines  = (document.getElementById('disciplines')) ? new Disciplines(this.elems) : null;
    this.Musts        = (document.getElementById('musts')) ? new Musts(this.elems) : null;
    this.Terms        = (document.getElementById('terms')) ? new Terms(this.elems) : null;
    this.Creators     = (document.getElementById('creators')) ? new Creators(this.elems) : null;
    this.About        = (document.getElementById('about')) ? new About(this.elems) : null;
    this.Museboard    = (document.getElementById('article-show') && document.getElementById('article-show').dataset.type == 'muse_boards') ? new Museboard() : null;
  }
}

const MM  = new App();
window.MM = MM;



// WEBPACK FOOTER //
// ./app/javascript/packs/app.js